export const SERVICE_IDENTIFIER = {
  ApiService: Symbol.for('ApiService'),
  AuthService: Symbol.for('AuthService'),
  CommentService: Symbol.for('CommentService'),
  ConstructionService: Symbol.for('ConstructionService'),
  CookieService: Symbol.for('CookieService'),
  ContactService: Symbol.for('ContactService'),
  CustomerService: Symbol.for('CustomerService'),
  NewCustomerService: Symbol.for('NewCustomerService'),
  DeliveryService: Symbol.for('DeliveryService'),
  HttpService: Symbol.for('HttpService'),
  ListService: Symbol.for('ListService'),
  MapService: Symbol.for('MapService'),
  SearchService: Symbol.for('SearchService'),
  TaskService: Symbol.for('TaskService'),
  TeamService: Symbol.for('TeamService'),
  UserService: Symbol.for('UserService'),
  CascadeService: Symbol.for('CascadeService'),
  ProductService: Symbol.for('ProductService'),
  OrganizerService: Symbol.for('OrganizerService'),
  OrganizerMockService: Symbol.for('OrganizerMockService'),
  UserProfileService: Symbol.for('UserProfileService'),
  SignalsService: Symbol.for('SignalsService'),
  SignalsMockService: Symbol.for('SignalsMockService'),
  PromiseService: Symbol.for('PromiseService'),
};
